<template>
    <div class="step-form-tabs redesign-tabs">
        <div v-for="(step, index) in steps" :key="'step-group-' + index" 
            class="step-form-group"
            :class="{ 'step-completed': currentStep > (index + 1), 'step-is-active': currentStep === (index + 1) }">
            
            <div class="step-form-tab" 
                :class="{ 'step-active': currentStep === (index + 1) }"
                @click="$emit('update:currentStep', index + 1)">
                <div class="step-icon-wrapper">
                    <div class="step-form-tab-icon" v-html="currentStep > (index + 1) ? checkIcon : step.icon"></div>
                </div>
                <div class="step-form-tab-text">{{ step.text }}</div>
            </div>
            
            <div v-if="index < steps.length - 1" class="step-form-tab-spacer">
                <div class="spacer-line"></div>
                <div class="spacer-line-active" :style="{ width: currentStep > (index + 1) ? '100%' : '0%' }"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GarantieStepper",
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        steps: {
            type: Array,
            required: true
            /* Expected format: [{ text: '...', icon: 'SVG_STRING' }] */
        }
    },
    data() {
        return {
            checkIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16"><path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/></svg>'
        };
    }
};
</script>






// WEBPACK FOOTER //
// src/components/Garantie/shared/GarantieStepper.vue